<template>
    <div class="goals-chart">
        <design-2021-apprentice-basic-bar-chart-component :series="barChartData.series" :options="barChartData.options">
        </design-2021-apprentice-basic-bar-chart-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-module-widget-basic-bar-chart-component",
    props: {
        modulesIn: Array,
    },
    methods: {
        getTotalHours() {
            let duration = 0;
            if(this.modulesIn.length){
                for (const module of this.modulesIn){
                    for (const date of module.module_dates){
                        if(date.module_users.length > 0){
                            duration += date.duration;
                        }
                    }
                }
            }
            return [duration];
        },
    },
    computed: {
        barChartData(){
           if(!this.modulesIn.length){
               return {
                   series: [],
                   options: {}
               }
           }

            return {
                series: [{
                    name: this.$t('modules.registered_hours'),
                    data: this.getTotalHours(),
                }],
                options: {
                    chart: {
                        toolbar:{
                            show: false,
                        },
                        type: 'bar',
                        height: '100px',
                        fontFamily: 'DM Sans, sans-serif',
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: true,
                            barHeight: '45%',
                            columnWidth: '100%',
                        }
                    },
                    dataLabels: {
                        enabled: true
                    },
                    xaxis: {
                        categories: [''],
                    },
                    yaxis: {
                        min: 0,
                        max: 150,
                    },
                    grid: {
                        yaxis: {
                            lines: {
                                show: false
                            }
                        },
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                    },

                }
            }
        },
    }
}
</script>

<style scoped>

</style>
